import CityPageTemplate from "../city-template/CityPageTemplate";
import { milesCityConfig } from "./data";

export default function MilesCityPage() {
  return <CityPageTemplate config={milesCityConfig} />;
}